import { Component, EventEmitter, Output } from '@angular/core';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProjectsFacade } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-add-project-scenario-consumer',
  templateUrl: './new-add-project-scenario-consumer.component.html',
  styleUrls: ['./new-add-project-scenario-consumer.component.scss'],
})
export class NewAddProjectScenarioConsumerComponent {
  modalLabel: any;
  myProjectData: any;
  myProjectScenarioConsumerForm!: FormGroup;
  submitted!: boolean;
  processColumnDef: any;
  packageItems = [{ name: 'PIQET PACKAGE Test' }];

  productClass: any;
  @Output() saveNewMyProjectScenarioConsumerEvent = new EventEmitter<any>();
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
  };

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    public projectFacade: ProjectsFacade
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.myProjectData = this.modal?.modalService?.config?.initialState?.['newMyProjects'];
  }

  ngOnInit() {
    this.myProjectScenarioConsumerForm = this.formBuilder.group({});
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForCountry(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
    this.projectFacade.clearDefaultMaterial();
  }

  onSave() {
    this.submitted = true;

    // this.saveNewMyProjectScenarioConsumerEvent.emit();
  }
}
